<template>
  <div
    class="w-fullbg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden"
  >
    <div
      class="border-b border-gray-50 flex items-center justify-between bg-gray-50/20"
    >
      <div class="flex items-center gap-1 px-3 py-3 border-b border-gray-100 bg-gray-50/50 flex items-center gap-1 w-full">
        <div
          :class="[
            'flex items-center justify-center w-5 h-5',
     
          ]"
        >
          <i :class="[`fa-solid fa-${icon} text-sm`]"></i>
        </div>
        <h2
          class="font-bold text-gray-700 text-[11px] uppercase tracking-wider"
        >
          {{ title }}
        </h2>
      </div>
    </div>

    <div class="py-2.5 px-3 bg-white">
      <div
        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-8 gap-y-6"
      >
        <div
          v-for="key in keys"
          :key="key"
          class="flex flex-col gap-1 transition-all"
        >
          <div class="flex items-center opacity-100">
            <i :class="[getIconClass(key), 'text-[11px]']"></i>
            <span
              class="text-slate-500 text-[10px] font-bold uppercase tracking-tight"
            >
              {{ formatLabel(key) }}
            </span>
          </div>

          <div class="min-h-[1.5rem] flex items-center">
            <span
              v-if="detail[key] !== undefined"
              class="text-[15px] font-bold text-gray-800 tracking-tight break-all"
            >
              {{ formatVal(key, detail[key]) }}
            </span>
            <span v-else class="text-sm text-gray-300 font-medium">—</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FieldSectionDisplay",
  props: {
    detail: { type: Object, default: () => ({}) },
    keys: { type: Array, required: true },
    title: { type: String, default: "Section Info" },
    icon: { type: String, default: "circle-info" },
    getIconClass: { type: Function, default: () => "fa-solid fa-tag" },
    iconColor: { type: String, default: "" },
    formatLabel: { type: Function, default: (val) => val.replace(/_/g, " ") },
    formatVal: { type: Function, default: (key, val) => val },
  },
};
</script>
